import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, set, get, child } from "firebase/database";
import { getAuth } from "firebase/auth";

function DeviceDashboard() {
  const [devices, setDevices] = useState([]);
  const [groups, setGroups] = useState({});
  const [groupNames, setGroupNames] = useState({});
  const [loading, setLoading] = useState(true);

  const [selectedDevice, setSelectedDevice] = useState(null);
  const [newGroup, setNewGroup] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const auth = getAuth();
  const db = getDatabase();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        const uid = user.uid;
        const mapRef = ref(db, `user_esp32_map/${uid}`);
        const groupRef = ref(db, `esp32_index`);
        const groupNameRef = ref(db, `group_name`);

        // 1. Load user's devices
        onValue(mapRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const shortIDs = Object.keys(data);
            setDevices(shortIDs);

            // 2. Load group names
            onValue(groupRef, (groupSnap) => {
              setGroups(groupSnap.val() || {});
              setLoading(false);
            }, { onlyOnce: true });

            onValue(groupNameRef, (snap) => {
              setGroupNames(snap.val() || {});
            }, { onlyOnce: true });
          } else {
            setDevices([]);
            setLoading(false);
          }
        });
      } else {
        setDevices([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleGroupEdit = (id) => {
    setSelectedDevice(id);
    setNewGroup(groups[id] && groups[id] !== "none" ? groups[id] : "");
    setErrorMsg("");
    setShowModal(true);
  };

  const handleSaveGroup = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid || !selectedDevice) return;

    const trimmedGroup = newGroup.trim();
    if (!trimmedGroup) return;

    const groupCheckRef = ref(db, `group_name/${trimmedGroup}`);
    const snapshot = await get(groupCheckRef);

    if (snapshot.exists() && snapshot.val() !== uid) {
      setErrorMsg("ชื่อกลุ่มนี้ถูกใช้งานแล้วโดยผู้ใช้รายอื่น กรุณาใช้ชื่ออื่น");
      return;
    }

    // Save both group assignment and ownership
    await set(ref(db, `esp32_index/${selectedDevice}`), trimmedGroup);
    await set(groupCheckRef, uid);

    setGroups((prev) => ({
      ...prev,
      [selectedDevice]: trimmedGroup
    }));

    setShowModal(false);
  };

  const filteredDevices = devices.filter(id => {
    const group = groups[id] || "";
    return id.toLowerCase().includes(searchTerm.toLowerCase()) || 
           group.toLowerCase().includes(searchTerm.toLowerCase());
  });

  if (loading) return <p className="text-center mt-4">Loading...</p>;

  return (
    <div className="container mt-5">
      <div className="card shadow-lg">
        <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="card-title mb-0">📋 อุปกรณ์ของคุณ</h4>
            <input
              type="text"
              className="form-control w-25"
              placeholder="ค้นหา"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead className="thead-dark">
                <tr>
                  <th>🔑 รหัสเครื่อง (Short ID)</th>
                  <th>👥 กลุ่ม</th>
                </tr>
              </thead>
              <tbody>
                {filteredDevices.map((id) => (
                  <tr key={id} onClick={() => handleGroupEdit(id)} style={{ cursor: "pointer" }}>
                    <td>{id}</td>
                    <td>{groups[id] === "none" || !groups[id] ? "ยังไม่อยู่ในกลุ่ม" : groups[id]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {devices.length === 0 && (
              <div className="text-center text-muted">ยังไม่มีอุปกรณ์ที่ผูกไว้</div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">กำหนดกลุ่มสำหรับ: {selectedDevice}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <select className="form-select mb-2" value={newGroup} onChange={(e) => setNewGroup(e.target.value)}>
                  <option value="">-- เลือกกลุ่มที่มี หรือพิมพ์ใหม่ --</option>
                  {Object.keys(groupNames).map((name) => (
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>
                <input
                  type="text"
                  className="form-control"
                  placeholder="หรือพิมพ์ชื่อกลุ่มใหม่ เช่น A1, B2"
                  value={newGroup}
                  onChange={(e) => setNewGroup(e.target.value)}
                />
                {errorMsg && <div className="text-danger mt-2">{errorMsg}</div>}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>ยกเลิก</button>
                <button className="btn btn-primary" onClick={handleSaveGroup}>บันทึก</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeviceDashboard;
